export default function fileSizeDisplay(size) {
  console.log("size" + size);

  if (size > 1000) return `${Math.floor(size / 1000)} KB`;
  else if (size > 1000000) return `${Math.floor(size / 1000000)} MB`;
  else return `${size} B`;
}
